module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"order":{"product_options":"選択：{0}"}}}')
  delete Component.options._Ctor
}
